/**
 * Drop-in replacement for nuxt-directus `useDirectusItems().getItems`, but routed
 * through our own server (`/api/cms`) instead of talking to Directus directly.
 *
 * Why: nuxt-directus needs the Directus origin on the client, so it published the CMS
 * URL into runtimeConfig.public and it showed up in every page's source. Fetching via
 * our own server route keeps the browser talking only to elker.com and keeps
 * DIRECTUS_URL server-only.
 *
 * The signature and return value match getItems exactly: call
 * `getItems({ collection, params })` and read the returned data the same way
 * (the array for a list collection, the object for a singleton, or the full
 * `{ data, meta }` when params.meta is set). So a call site only needs to swap
 * `useDirectusItems()` for `useCms()`; the query object is unchanged.
 */
export const useCms = () => {
  const getItems = (data) => {
    return $fetch('/api/cms', {
      method: 'POST',
      body: {
        collection: data.collection,
        params: data.params || {},
      },
    })
  }
  return { getItems }
}
